import styled, { css, keyframes } from 'styled-components';

export const setLayoutWidth = () => {
  return css`
    width: 96%;
    max-width: 1920px;

    ${({ theme }) => theme.breakpoints.up('md')} {
      width: 96%;
    }
    ${({ theme }) => theme.breakpoints.up('lg')} {
      width: 93%;
    }
    ${({ theme }) => theme.breakpoints.up('xl')} {
      width: 85%;
    }
  `;
};

export const BaseContainer = styled.div<{ footer?: boolean }>`
  ${setLayoutWidth};
  margin: 0 auto;
  margin-bottom: ${props => !props.footer && '70px'};
  min-height: ${props => !props.footer && '60vh'};
`;

const loadingSpinner = keyframes`
  from {
      transform: rotate(0turn);
    }
    to {
      transform: rotate(1turn);
    }
`;

export const LoadingSpinner = styled.div<{
  width?: string;
  height?: string;
  isPrimary?: boolean;
}>`
  width: ${({ width }) => (width ? width : '10px')};
  height: ${({ height }) => (height ? height : '10px')};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: ${({ isPrimary }) =>
    isPrimary
      ? '4px solid rgba(32, 154, 214, 1)'
      : '4px solid rgba(0, 0, 0, 0.23)'};
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: ${loadingSpinner} 1s ease infinite;
`;

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PageTitle = styled.h1`
  width: 100%;
  font-size: 2rem;
  font-weight: 500;
  margin: 10px 0px;
  ${({ theme }) => theme.breakpoints.down('md')} {
    font-size: 1.5rem;
  }
  ${({ theme }) => theme.breakpoints.down('sm')} {
    margin: 20px 0;
  }
  /* border: 1px solid red; */
`;

export const IconWrapper = styled.div<{
  width?: string;
}>`
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: transparent;

  &:hover {
    background: rgba(0, 0, 0, 0.04);
    border-radius: 50%;
  }
`;

export const OrderSuccessMessage = styled.div`
  padding: 17px 7px;
  border-radius: 5px;
  color: #649942;
  font-weight: 500;
  font-size: 1.1rem;
  text-align: center;
  width: 100%;
  margin: 0 auto;
  margin-bottom: 20px;

  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Link = styled.a`
  color: rgba(32, 154, 214, 1);
  display: inline;
  margin: 0px 2px;
  cursor: pointer;
`;

export const BaseErrorContainer = styled.div`
  width: 100%;
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  line-height: 2rem;
  margin-top: 10%;
  margin-bottom: 10%;
  font-size: 1.1rem;
`;

export const FlexContainer = styled.div<{
  direction?: 'row' | 'column';
  justify?: 'center' | 'flex-start' | 'flex-end' | 'space-between';
  align?: 'center' | 'flex-start' | 'flex-end' | 'space-between';
  gap?: string;
  margin?: string;
  padding?: string;
}>`
  display: flex;
  flex-direction: ${({ direction }) => direction || 'row'};
  justify-content: ${({ justify }) => justify || 'center'};
  align-items: ${({ align }) => align || 'center'};
  gap: ${({ gap }) => gap || '0px'};
  margin: ${({ margin }) => margin || '0px'};
  padding: ${({ padding }) => padding || '0px'};
`;
